import React, { useState } from 'react';
import { PhoneIcon, MessageSquareIcon, MenuIcon, XIcon } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF, SMS_HREF } from '../lib/contact';
const NAV_LINKS = [{
  label: 'Our barrels',
  href: '#gallery'
}, {
  label: 'Buy or Rent',
  href: '#offerings'
}, {
  label: 'Our Story',
  href: '#story'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 border-b-2 border-oak-dark/30 bg-parchment/95 backdrop-blur" data-id="element-78" data-mp="2rlvsg6pnav9b">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6" data-id="element-79" data-mp="2wjfdpqkrg8ar">
        <a href="#top" className="flex flex-col leading-none" data-id="element-80" data-mp="31e1u685p8r1p">
          <span className="font-display text-xl text-oak-dark sm:text-2xl" data-id="element-81" data-mp="36a0cpf4cjeu7">Castle Barrel</span>
          <span className="font-stamp text-[10px] uppercase tracking-[0.25em] text-wine sm:text-xs" data-id="element-82" data-mp="3bb66zhdnna5u">
            Santa Barbara &middot; Handmade
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary" data-id="element-83" data-mp="2wkkzjf96ns4t">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="font-body text-sm font-semibold text-bark transition-colors hover:text-wine" data-id="element-84" data-mp="2rlhz6845ea36">
              {link.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-2 sm:flex" data-id="element-85" data-mp="3fbcdyv8128q2">
          <a href={SMS_HREF} className="inline-flex items-center gap-2 rounded-sm border-2 border-oak-dark px-3 py-2 font-body text-sm font-semibold text-oak-dark transition-colors hover:bg-oak-dark hover:text-cream" data-id="element-86" data-mp="3fasvndegtibi">
            <MessageSquareIcon className="h-4 w-4" aria-hidden="true" data-id="element-87" data-mp="30mpr88g2meot" />
            Text
          </a>
          <a href={PHONE_HREF} className="inline-flex items-center gap-2 rounded-sm bg-wine px-3 py-2 font-body text-sm font-semibold text-cream transition-colors hover:bg-oak-dark" data-id="element-88" data-mp="1wz9kafjlbe0">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-89" data-mp="1remeekg6a2gp" />
            {PHONE_DISPLAY}
          </a>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} className="inline-flex items-center justify-center rounded-sm border-2 border-oak-dark p-2 text-oak-dark lg:hidden" aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-90" data-mp="1wc4pagdr2rrc">
          {open ? <XIcon className="h-5 w-5" data-id="element-91" data-mp="18p6cbsoua1y6" /> : <MenuIcon className="h-5 w-5" data-id="element-92" data-mp="1cof62xjvpztq" />}
        </button>
      </div>

      {open && <div className="border-t border-oak-dark/20 bg-parchment lg:hidden" data-id="element-93" data-mp="yovyq6yw6sih">
          <nav className="mx-auto flex max-w-6xl flex-col px-4 py-2 sm:px-6" aria-label="Mobile" data-id="element-94" data-mp="yr0cdgmlf5vy">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="border-b border-oak-dark/10 py-3 font-body text-base font-semibold text-bark" data-id="element-95" data-mp="2t2f3o1v95ddt">
                {link.label}
              </a>)}
            <div className="flex gap-2 py-3" data-id="element-96" data-mp="hgcwuwrmr94s">
              <a href={SMS_HREF} className="inline-flex flex-1 items-center justify-center gap-2 rounded-sm border-2 border-oak-dark px-3 py-2 font-body text-base font-semibold text-oak-dark" data-id="element-97" data-mp="hdgyj7bveift">
                <MessageSquareIcon className="h-4 w-4" aria-hidden="true" data-id="element-98" data-mp="154mmyavvmj1q" />
                Text
              </a>
              <a href={PHONE_HREF} className="inline-flex flex-1 items-center justify-center gap-2 rounded-sm bg-wine px-3 py-2 font-body text-base font-semibold text-cream" data-id="element-99" data-mp="1051d35f64qa8">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-100" data-mp="1a4s775zth39s" />
                Call
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}